var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgForest = function SvgForest(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38087 4.68791C7.76657 4.62141 8.19882 4.56821 8.68427 4.52831C11.2778 4.32881 12.8472 3.05201 13.3326 1.34961C9.90787 2.97886 5.63857 0.983859 4.83392 4.58816L4.42162 6.50336C4.42162 6.50336 4.42162 6.50336 4.42162 6.49671C4.42162 6.51001 4.42162 6.51666 4.41497 6.51666L3.65022 10.0412L3.20467 12.116L2.66602 14.6496C5.29277 14.4967 5.65852 11.6904 6.07747 9.60891C6.66932 9.37616 7.14147 9.28306 7.26782 9.25646C9.49557 8.77101 10.5662 7.63386 10.9918 6.15091C9.94112 6.76936 8.12567 6.63636 6.54962 7.04866C6.56957 7.04866 6.58287 7.03536 6.59617 7.02871C6.62942 6.80926 6.98852 5.23321 7.38087 4.68791Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "forest.0210112f47506301e7ffae4de5a16674.svg";